module.exports = __webpack_public_path__ + "img/7.6978b1b8.jpg";